var render = function render(){var _vm=this,_c=_vm._self._c;return _c('lottie-animation',{ref:"anim",staticClass:"svg_wrapper hover_lottie",attrs:{"animationData":require('@/assets/anim/attendance.json'),"loop":true,"autoPlay":true,"speed":1}})
}
var staticRenderFns = []

export { render, staticRenderFns }